import { RouteObject } from "react-router";
import { SMART_HANDLER_PATH } from "./consts";
import loader from "./loader";

export default (): RouteObject => ({
  path: SMART_HANDLER_PATH,
  loader,
});
